
























































































































import Vue from 'vue'
import dayjs from 'dayjs'
import moment from 'moment'
import {
  MasterlinkTenantServiceProxy,
} from '@/service-proxies/app-v2/system.service-proxies'
import { TenantCommonSettingDTO, TenantSettingServiceProxy } from '@/service-proxies/app-v2/system.service-proxies' 
const masterlinkTenantService = new MasterlinkTenantServiceProxy()
const tssp = new TenantSettingServiceProxy()

export default Vue.extend({
  data() {
    return {
      form: this.$form.createForm(this),
      paramValues: 0
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => ({})
    }
  },
  watch:{
    'formData':{
      handler(){
        tssp.getTenantSetting("is-copyright-hidden","Copyright-info",this.formData.tenantId).then(res =>{
          if(res){
            this.paramValues = res.paramValue === null ? 0 : Number(res.paramValue)
          } else {
            this.paramValues = 0
          }
        })
      },
      deep: true
    }
  },
  methods: {
    moment,
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    disabledDate(current: any) {
      // Can not select days before today and today
      return current && current < moment().endOf('day')
    },
    onClose() {
      this.form.resetFields()
      this.$emit('closemodal', false)
    },
    onSave() {
      this.form.validateFields((err: any, values: any) => {
        if (!err) {
          const paramValue = values.paramValue
          delete values.paramValue
          console.log(values,paramValue)
          values.ids = this.formData.id
          if (values.expireTime) {
            values.expireTime = dayjs(Number(values.expireTime)).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          }

          // console.log(values);
          const dage = {
            tenantId: this.formData.tenantId,
            paramKey: "is-copyright-hidden",
            paramValue: paramValue,
            paramName: "Copyright-info"
          } as TenantCommonSettingDTO
          tssp.saveTenantSetting(dage).then(() => {
            console.log(23232)
          })
          masterlinkTenantService.setting(values).then(res => {
            this.$message.success(this.$t('page_tenant_have_been_saved'))
            this.form.resetFields()
            this.$emit('closemodal', true)
          })
        }
      })
    }
  }
})
